<template>
    <span class="cart-count">&nbsp;{{ quantityFormatter($store.getters.cartTotalCount) }}</span>
</template>

<script>
export default {
    name: 'cart-total',
}
</script>
